import React from 'react';
import SEOHead from '../components/shared/SEOHead';
import { getPageSEO } from '../utils/seoConfig';
import ContactUs from '../components/landing-page/ContactUs';
import LandingPageNavbar from '../components/landing-page/LandingPageNavbar';

const ContactUsPage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("contactUs")} />
      <div className="no-scrollbar no-scrollbar::-webkit-scrollbar">
             <LandingPageNavbar />
    <div className='py-12 bg-gray-50'>
        <ContactUs />
        </div>
     
    </div>
    </>
  );
};

export default ContactUsPage;